module.exports = __webpack_public_path__ + "img/cc.92a87392.png";